import type { AgentCardItem } from "@/lib/api";
import type { CardFinishMeta } from "@/lib/cards";

/**
 * Canonical supply copy for the Collection page — one format everywhere:
 * capped finishes read "{minted} / {cap} minted", open editions read "Open edition".
 */
export function supplyLine(
  meta: CardFinishMeta,
  item?: Pick<AgentCardItem, "mintedCount" | "supplyCap" | "owned" | "count">,
): string {
  const cap = item?.supplyCap ?? meta.supplyCap;
  if (cap == null) return "Open edition";
  // Defensive floor: owning N copies proves at least N were minted. Never let
  // a stale/racy mintedCount counter contradict the card the viewer is
  // holding — the real fix is an atomic backend counter, this is the net.
  const minted = Math.max(item?.mintedCount ?? 0, item?.owned ? item.count : 0);
  return `${minted} / ${cap} minted`;
}
